


































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BuilderDeviceChatsPreviewMessageStub extends Vue {
  @Prop({ required: true, type: String }) title!: string

  @Prop({ required: true }) image!: string | File | null

  @Prop({ required: true }) avatar!: string | File | null

  get imageUrl(): string | null {
    if (!this.image) {
      return null
    }
    return this.image instanceof File ? URL.createObjectURL(this.image) : this.image
  }
}
